import CookieUtil from "./CookieUtil";
import { cookieTypes } from "./Types";
import Utils from "./Utils";
import * as signalR from "@aspnet/signalr";

class KsSignal {
    private url = Utils.GetBaseUrl() + "/LightHub";
    // private url = "https://lamp.kingsunsmart.com/LightHub";
    private sign: signalR.HubConnection | null = null;
    private projectSid = "";
    private interval: number | null = null;
    vue: any = null;

    constructor(vue: any) {
        this.vue = vue;
    }

    onBroadcastAlarmDatas(data: any) {
        this.vue.$store.commit("setAlarmList", data);
    }
    onLoopActionDatas(data: any) {
        this.vue.$store.commit("setLoopList", data);
    }
    onDeviceStateData(data: any) {
        this.vue.$store.commit("setDeviceState", data);
    }

    startSign(): Promise<void> {
        return new Promise((res, rej) => {
            if (!this.sign) {
                this.sign = new signalR.HubConnectionBuilder()
                    .withUrl(this.url)
                    .build();
                this.sign.serverTimeoutInMilliseconds = 60000;
    
                this.sign.on("BroadcastAlarmDatas", (data: any) => {
                    this.onBroadcastAlarmDatas(data);
                    console.log("收到告警推送", data); // 打开日志观察
                });
                this.sign.on("BroadcastLoopState", (data: any) => {
                    this.onLoopActionDatas(data);
                    console.log("收到回路推送", data);
                });
                this.sign.on("BroadcastDeviceLogin", (data: any) => {
                    this.onDeviceStateData(data);
                    console.log("收到设备状态推送", data);
                });
    
                this.sign.start()
                    .then(() => {
                        this.projectSid = CookieUtil.getCookie(cookieTypes.XC_COOKIES_PROJECTSID) || "";
                        // ✅ 连接成功 订阅项目
                        this.sign!.send("ListenProject", this.projectSid);
                        console.log("SignalR连接成功，订阅项目sid：", this.projectSid);
                        res();
                    })
                    .catch((err: any) => {
                        console.error("连接失败", err);
                        this.sign = null;
                        rej(err);
                    });
            } else {
                res();
            }
        });
    }

    /**
     * 启动轮询监控（只允许运行一个interval，不再递归调用自身）
     */
    reStartSign() {
        // 如果已有定时器，先清除
        if (this.interval !== null) {
            window.clearInterval(this.interval);
            this.interval = null;
        }

        this.interval = window.setInterval(async () => {
            try {
                if (!this.sign) {
                    // 不存在连接，尝试建立
                    await this.startSign();
                } else if (this.sign.state !== signalR.HubConnectionState.Connected) {
                    // 连接断开，销毁旧实例重建
                    this.sign = null;
                    await this.startSign();
                } else {
                    // 连接正常，检测projectSid变更
                    const psid = CookieUtil.getCookie(cookieTypes.XC_COOKIES_PROJECTSID) || "";
                    if (psid !== this.projectSid) {
                        this.projectSid = psid;
                        this.sign.send("ListenProject", this.projectSid);
                    }
                }
            } catch (err) {
                console.warn("SignalR重连尝试失败", err);
                this.sign = null;
            }
        }, 2000);
    }

    /**
     * 【重要】页面销毁主动调用，释放资源！！
     * 在Vue组件 onUnmounted / beforeDestroy 执行
     */
    destroy() {
        // 清除定时器
        if (this.interval !== null) {
            window.clearInterval(this.interval);
            this.interval = null;
        }
        // 关闭signalr连接
        if (this.sign) {
            this.sign.stop().catch(() => {
                //
            });
            this.sign = null;
        }
    }
}

export default KsSignal;